<section class="section-screenshot pb-64" *ngIf="languageService.feedbacksEnabled">
  <div class="container--landing">
    <div class="landing-subtitle-dash" [innerHTML]="'landing.feedbacks' | translate"></div>

    <div class="screenshot-image relative mb-12 md:mb-0">
      <img src="assets/assets-site/images/landing/feedbacks.png" alt="" class="screenshot-inside" />
    </div>

    <div class="testimony-block">
      <div class="testimony-title">
        {{ 'landing.feedback_text' | translate }}
      </div>

      <ng-container *ngIf="languageService.landingTestimony('feedbacks')">
        <div class="testimony-separator"></div>
        <div
          class="testimony-text"
          [innerHTML]="languageService.landingTestimony('feedbacks').text"
        ></div>
        <div class="testimony-author">
          <img
            src="assets/assets-site/images/landing/ancrage-author.svg"
            alt=""
            class="testimony-author-icon"
          />
          <div class="testimony-author-content">
            <div class="testimony_author_name">
              {{ languageService.landingTestimony('feedbacks').author }}
            </div>
            <div
              class="testimony-author-position"
              *ngIf="languageService.landingTestimony('feedbacks').rank"
            >
              {{ languageService.landingTestimony('feedbacks').rank }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="landing-gradient" *ngIf="onLanding"></div>
</section>
